const abc = [
  {
    id: 0,
    Title: "Avatar",
    Year: "2009",
    rated: "PG-13",
    released: "18 Dec 2009",
    Runtime: "162 min",
    Genre: "Action, Adventure, Fantasy",
    Director: "James Cameron",
    Writer: "James Cameron",
    Actors: "Sam Worthington, Zoe Saldana, Sigourney Weaver, Stephen Lang",
    Plot: "A paraplegic marine dispatched to the moon Pandora on a unique mission becomes torn between following his orders and protecting the world he feels is his home.",
    Language: "English, Spanish",
    Country: "USA, UK",
    Awards: "Won 3 Oscars. Another 80 wins & 121 nominations.",
    poster:
      "https://posters.movieposterdb.com/23_01/2009/499549/l_avatar-movie-poster_c111a145.png",
    Metascore: "83",
    imdbRating: "7.9",
    imdbVotes: "890,617",
    imdbID: "tt0499549",
    Type: "movie",
    Response: "True",
    images: [
      "https://img1.hotstarext.com/image/upload/f_auto,h_136/sources/r1/cms/prod/9548/1369548-t-4a605a90e6ca",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjEyOTYyMzUxNl5BMl5BanBnXkFtZTcwNTg0MTUzNA@@._V1_SX1500_CR0,0,1500,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNzM2MDk3MTcyMV5BMl5BanBnXkFtZTcwNjg0MTUzNA@@._V1_SX1777_CR0,0,1777,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTY2ODQ3NjMyMl5BMl5BanBnXkFtZTcwODg0MTUzNA@@._V1_SX1777_CR0,0,1777,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTMxOTEwNDcxN15BMl5BanBnXkFtZTcwOTg0MTUzNA@@._V1_SX1777_CR0,0,1777,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTYxMDg1Nzk1MV5BMl5BanBnXkFtZTcwMDk0MTUzNA@@._V1_SX1500_CR0,0,1500,999_AL_.jpg",
    ],
  },
  {
    id: 1,
    Title: "The Avengers",
    Year: "2012",
    rated: "PG-13",
    released: "04 May 2012",
    Runtime: "143 min",
    Genre: "Action, Sci-Fi, Thriller",
    Director: "Joss Whedon",
    Writer: "Joss Whedon (screenplay), Zak Penn (story), Joss Whedon (story)",
    Actors: "Robert Downey Jr., Chris Evans, Mark Ruffalo, Chris Hemsworth",
    Plot: "Earth's mightiest heroes must come together and learn to fight as a team if they are to stop the mischievous Loki and his alien army from enslaving humanity.",
    Language: "English, Russian",
    Country: "USA",
    Awards: "Nominated for 1 Oscar. Another 34 wins & 75 nominations.",
    poster:
      "https://posters.movieposterdb.com/12_01/2012/848228/l_848228_df20a875.jpg",
    Metascore: "69",
    imdbRating: "8.1",
    imdbVotes: "1,003,301",
    imdbID: "tt0848228",
    Type: "movie",
    Response: "True",
    images: [
      "https://img1.hotstarext.com/image/upload/f_auto,h_136/sources/r1/cms/prod/52/1370052-t-c192aeeb4c31",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTA0NjY0NzE4OTReQTJeQWpwZ15BbWU3MDczODg2Nzc@._V1_SX1777_CR0,0,1777,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjE1MzEzMjcyM15BMl5BanBnXkFtZTcwNDM4ODY3Nw@@._V1_SX1777_CR0,0,1777,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjMwMzM2MTg1M15BMl5BanBnXkFtZTcwNjM4ODY3Nw@@._V1_SX1777_CR0,0,1777,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTQ4NzM2Mjc5MV5BMl5BanBnXkFtZTcwMTkwOTY3Nw@@._V1_SX1777_CR0,0,1777,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTc3MzQ3NjA5N15BMl5BanBnXkFtZTcwMzY5OTY3Nw@@._V1_SX1777_CR0,0,1777,999_AL_.jpg",
    ],
  },
  {
    id: 2,
    Title: "Vikings",
    Year: "2013–",
    rated: "TV-14",
    released: "03 Mar 2013",
    Runtime: "44 min",
    Genre: "Action, Drama, History",
    Director: "N/A",
    Writer: "Michael Hirst",
    Actors: "Travis Fimmel, Clive Standen, Gustaf Skarsgård, Katheryn Winnick",
    Plot: "The world of the Vikings is brought to life through the journey of Ragnar Lothbrok, the first Viking to emerge from Norse legend and onto the pages of history - a man on the edge of myth.",
    Language: "English, Old English, Norse, Old, Latin",
    Country: "Ireland, Canada",
    Awards:
      "Nominated for 7 Primetime Emmys. Another 17 wins & 49 nominations.",
    poster:
      "https://posters.movieposterdb.com/13_07/2013/2306299/l_2306299_e4d03de6.jpg",
    Metascore: "N/A",
    imdbRating: "8.6",
    imdbVotes: "198,041",
    imdbID: "tt2306299",
    Type: "series",
    totalSeasons: "5",
    Response: "True",
    images: [
      "https://occ-0-3752-2186.1.nflxso.net/dnm/api/v6/LmEnxtiAuzezXBjYXPuDgfZ4zZQ/AAAABQ-ZQ3oPc7b85jC6RlYHta0VDciPakkztJ02ojxodAUyFcqA-IlJu8S7qnMSzJSAI9ACorl6WFfAgdtey5bwa9zkb9Y2RKkZdlPzVcmYj1bx.png?r=896",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjM5MTM1ODUxNV5BMl5BanBnXkFtZTgwNTAzOTI2ODE@._V1_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNzU2NDcxODMyOF5BMl5BanBnXkFtZTgwNDAzOTI2ODE@._V1_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjMzMzIzOTU2M15BMl5BanBnXkFtZTgwODMzMTkyODE@._V1_SY1000_SX1500_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTQ2NTQ2MDA3NF5BMl5BanBnXkFtZTgwODkxMDUxODE@._V1_SY1000_SX1500_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTcxOTQ3NTA5N15BMl5BanBnXkFtZTgwMzExMDUxODE@._V1_SY1000_SX1500_AL_.jpg",
    ],
  },
  {
    id: 3,
    Title: "Narcos",
    Year: "2015–",
    rated: "TV-MA",
    released: "28 Aug 2015",
    Runtime: "49 min",
    Genre: "Biography, Crime, Drama",
    Director: "N/A",
    Writer: "Carlo Bernard, Chris Brancato, Doug Miro, Paul Eckstein",
    Actors: "Wagner Moura, Boyd Holbrook, Pedro Pascal, Joanna Christie",
    Plot: "A chronicled look at the criminal exploits of Colombian drug lord Pablo Escobar.",
    Language: "English, Spanish",
    Country: "USA",
    Awards: "Nominated for 2 Golden Globes. Another 4 nominations.",
    poster:
      "https://posters.movieposterdb.com/15_09/2015/2707408/l_2707408_45242cce.jpg",
    Metascore: "N/A",
    imdbRating: "8.9",
    imdbVotes: "118,680",
    imdbID: "tt2707408",
    Type: "series",
    totalSeasons: "2",
    Response: "True",
    images: [
      "https://occ-0-3752-2186.1.nflxso.net/dnm/api/v6/tx1O544a9T7n8Z_G12qaboulQQE/AAAABSfH7g95oOQujxJKmNM2hMXTo4igNawjofOgvL86rdCI2TnL4-QhYcfpsaHjLAnblKpAh_8w2zXVkhpIgD9WOtvVMRyFXKaPwWFamX4u6yHpJobknNxFBe5yWAdpjiepTYOPTuazy-1Tow8VWgpMEv-eJRsbL-dLhm3OSTmwKWWfK88pHWXAzA.png?r=de0",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTk2MDMzMTc0MF5BMl5BanBnXkFtZTgwMTAyMzA1OTE@._V1_SX1500_CR0,0,1500,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjIxMDkyOTEyNV5BMl5BanBnXkFtZTgwNjY3Mjc3OTE@._V1_SY1000_SX1500_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjA2NDUwMTU2NV5BMl5BanBnXkFtZTgwNTI1Mzc3OTE@._V1_SY1000_CR0,0,1499,1000_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BODA1NjAyMTQ3Ml5BMl5BanBnXkFtZTgwNjI1Mzc3OTE@._V1_SY1000_CR0,0,1499,1000_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTU0NzQ0OTAwNl5BMl5BanBnXkFtZTgwMDAyMzA1OTE@._V1_SX1500_CR0,0,1500,999_AL_.jpg",
    ],
  },
  {
    id: 4,
    Title: "Breaking Bad",
    Year: "2008–2013",
    rated: "TV-14",
    released: "20 Jan 2008",
    Runtime: "49 min",
    Genre: "Crime, Drama, Thriller",
    Director: "N/A",
    Writer: "Vince Gilligan",
    Actors: "Bryan Cranston, Anna Gunn, Aaron Paul, Dean Norris",
    Plot: "A high school chemistry teacher diagnosed with inoperable lung cancer turns to manufacturing and selling methamphetamine in order to secure his family's financial future.",
    Language: "English, Spanish",
    Country: "USA",
    Awards: "Won 2 Golden Globes. Another 132 wins & 218 nominations.",
    poster:
      "https://posters.movieposterdb.com/08_04/2008/903747/l_903747_a1327335.jpg",
    Metascore: "N/A",
    imdbRating: "9.5",
    imdbVotes: "889,883",
    imdbID: "tt0903747",
    Type: "series",
    totalSeasons: "5",
    Response: "True",
    images: [
      "https://occ-0-3752-2186.1.nflxso.net/dnm/api/v6/LmEnxtiAuzezXBjYXPuDgfZ4zZQ/AAAABeJo_eP3qXqDWnaRWhbGbLu1VN_yACCncu6G7-CW4pCSzZD74lWxcVvYw4koEFN9bmO2PERuTLR7KiXVURG1MSTFXlS9GTB0selwbgbCBtTR.png?r=295",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTgyMzI5NDc5Nl5BMl5BanBnXkFtZTgwMjM0MTI2MDE@._V1_SY1000_CR0,0,1498,1000_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTQ2NDkwNDk5NV5BMl5BanBnXkFtZTgwNDM0MTI2MDE@._V1_SY1000_CR0,0,1495,1000_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTM4NDcyNDMzMF5BMl5BanBnXkFtZTgwOTI0MTI2MDE@._V1_SY1000_CR0,0,1495,1000_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTAzMTczMjM3NjFeQTJeQWpwZ15BbWU4MDc1MTI1MzAx._V1_SY1000_CR0,0,1495,1000_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjA5MTE3MTgwMF5BMl5BanBnXkFtZTgwOTQxMjUzMDE@._V1_SX1500_CR0,0,1500,999_AL_.jpg",
    ],
  },
  {
    id: 5,
    ComingSoon: true,
    Title: "Doctor Strange",
    Year: "2016",
    rated: "N/A",
    released: "04 Nov 2016",
    Runtime: "N/A",
    Genre: "Action, Adventure, Fantasy",
    Director: "Scott Derrickson",
    Writer:
      "Scott Derrickson (screenplay), C. Robert Cargill (screenplay), Jon Spaihts (story by), Scott Derrickson (story by), C. Robert Cargill (story by), Steve Ditko (comic book)",
    Actors:
      "Rachel McAdams, Benedict Cumberbatch, Mads Mikkelsen, Tilda Swinton",
    Plot: "After his career is destroyed, a brilliant but arrogant and conceited surgeon gets a new lease on life when a sorcerer takes him under her wing and trains him to defend the world against evil.",
    Language: "English",
    Country: "USA",
    Awards: "N/A",
    poster:
      "https://posters.movieposterdb.com/20_08/2013/1211837/l_1211837_b473cc46.jpg",
    Metascore: "N/A",
    imdbRating: "N/A",
    imdbVotes: "N/A",
    imdbID: "tt1211837",
    Type: "movie",
    Response: "True",
    images: [
      "https://img1.hotstarext.com/image/upload/f_auto,h_136/sources/r1/cms/prod/1175/1371175-t-00259386fecd",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjM3ODc1ODI5Ml5BMl5BanBnXkFtZTgwODMzMDY3OTE@._V1_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTgxNTAyNTU0NV5BMl5BanBnXkFtZTgwNzMzMDY3OTE@._V1_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjE5NDc5NzUwNV5BMl5BanBnXkFtZTgwMDM3MDM2NzE@._V1_.jpg",
    ],
  },
  {
    id: 6,
    ComingSoon: true,
    Title: "Rogue One: A Star Wars Story",
    Year: "2016",
    rated: "N/A",
    released: "16 Dec 2016",
    Runtime: "N/A",
    Genre: "Action, Adventure, Sci-Fi",
    Director: "Gareth Edwards",
    Writer:
      "Chris Weitz (screenplay), Tony Gilroy (screenplay), John Knoll (story), Gary Whitta (story), George Lucas (characters)",
    Actors: "Felicity Jones, Riz Ahmed, Mads Mikkelsen, Ben Mendelsohn",
    Plot: "The Rebellion makes a risky move to steal the plans to the Death Star, setting up the epic saga to follow.",
    Language: "English",
    Country: "USA",
    Awards: "1 nomination.",
    poster:
      "https://posters.movieposterdb.com/21_03/2016/3748528/l_3748528_65f0feb0.jpg",
    Metascore: "N/A",
    imdbRating: "N/A",
    imdbVotes: "N/A",
    imdbID: "tt3748528",
    Type: "movie",
    Response: "True",
    images: [
      "https://img1.hotstarext.com/image/upload/f_auto,h_136/sources/r1/cms/prod/8789/1368789-t-84e9011347e0",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjE3MzA4Nzk3NV5BMl5BanBnXkFtZTgwNjAxMTc1ODE@._V1_SX1777_CR0,0,1777,744_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNDMxMTQzMjQxM15BMl5BanBnXkFtZTgwNzAxMTc1ODE@._V1_SX1777_CR0,0,1777,744_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTUyNjkxOTk5NV5BMl5BanBnXkFtZTgwODAxMTc1ODE@._V1_SX1777_CR0,0,1777,744_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNjM4MzExNDAyNl5BMl5BanBnXkFtZTgwOTAxMTc1ODE@._V1_SX1777_CR0,0,1777,744_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjE3NTgxMDcyNV5BMl5BanBnXkFtZTgwMDExMTc1ODE@._V1_SX1777_CR0,0,1777,744_AL_.jpg",
    ],
  },
  {
    id: 7,
    ComingSoon: true,
    Title: "Luke Cage",
    Year: "2016–",
    rated: "TV-MA",
    released: "30 Sep 2016",
    Runtime: "55 min",
    Genre: "Action, Crime, Drama",
    Director: "N/A",
    Writer: "Cheo Hodari Coker",
    Actors: "Mahershala Ali, Mike Colter, Frankie Faison, Erik LaRay Harvey",
    Plot: "Given superstrength and durability by a sabotaged experiment, a wrongly accused man escapes prison to become a superhero for hire.",
    Language: "English",
    Country: "USA",
    Awards: "N/A",
    poster:
      "https://posters.movieposterdb.com/22_08/2016/3322314/l_3322314_668afee7.jpg",
    Metascore: "N/A",
    imdbRating: "N/A",
    imdbVotes: "N/A",
    imdbID: "tt3322314",
    Type: "series",
    totalSeasons: "1",
    Response: "True",
    images: [
      "https://img1.hotstarext.com/image/upload/f_auto,h_136/sources/r1/cms/prod/9761/1379761-t-9a429891a8c7",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjMxNjc1NjI0NV5BMl5BanBnXkFtZTgwNzA0NzY0ODE@._V1_SY1000_CR0,0,1497,1000_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjI1MDg3NjY2OF5BMl5BanBnXkFtZTgwNDE1NDU4OTE@._V1_SY1000_CR0,0,1497,1000_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BOTYzOTQyNDYxNl5BMl5BanBnXkFtZTgwNzA1NDU4OTE@._V1_SY1000_CR0,0,1498,1000_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTgxMjA3MTQ5Ml5BMl5BanBnXkFtZTgwOTA1NDU4OTE@._V1_SY1000_CR0,0,1498,1000_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjMyNjg5ODYwNF5BMl5BanBnXkFtZTgwMTE1NDU4OTE@._V1_SY1000_CR0,0,1477,1000_AL_.jpg",
    ],
  },
];

export default abc;
